/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankIDCompanyCheck } from './bank-id-company-check';
import { SimpleUser } from './simple-user';
import { Address } from './address';
import { DealflowFile } from './dealflow-file';
import { CompanySelfPublishTag } from './company-self-publish-tag';

export interface DeckCompanyDetail {
  readonly id: string;
  readonly name: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly total_raised: number;
  readonly dealflow_files: Array<DealflowFile>;
  readonly address: Address;
  readonly representatives: Array<SimpleUser>;
  readonly pep_data: BankIDCompanyCheck;
  readonly self_publish_tags: Array<CompanySelfPublishTag>;
  readonly organization_number: string;
  readonly total_shares: number;
  readonly capital: number | null;
}
